export default {"src":"/_next/static/media/kitchen.45428a68.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};